import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-mi-physical-verifications',
  templateUrl: './mi-physical-verifications.component.html',
  styleUrls: ['./mi-physical-verifications.component.scss']
})
export class MiPhysicalVerificationsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        // this.autoId = params.autoId;
        // this.appId = params.appId;
        this.items = [
          { label: 'Pending', routerLink: `/${parentRoute}/physical-verification/pending`},
          { label: 'Current', routerLink: `/${parentRoute}/physical-verification/current`},
          { label: 'Further Action Taken', routerLink: `/${parentRoute}/physical-verification/approved` },          
        ];
      }
      );
  }
}
